export const EVENT_TYPES = {
    IS_LIVE: 'isLive',
    COMING_SOON: 'comingSoon',
    ON_DEMAND: 'onDemand',
    OFFLINE: 'offLine'

}

export const eventTypes = {
    START: "Start",
    PAUSE: "Pause",
    RESUME: "Resume",
    CLOSE: "Close",
    PROGRESS_MARK: "ProgressMark",
    FIRTS_QUARTILE: "FirstQuartile",
    MID_POINT: "MidPoint",
    THIRD_QUARTILE: "ThirdQuartile",
    COMPLETE: "Complete",
    ENDED: "Ended",
    STREAMING_PROGRESS: "StreamingProgress",
    START_BUFFERING: "Start-Buffering",
    RE_BUFFERING: "Re-Buffering",
    PLAYBACK_ERROR: "PlaybackError"
}